// extracted by mini-css-extract-plugin
export default {"colorList":"A6riRo","item":"sANJg_","color":"YF84Mc","white":"UhY6Zz","active":"KwdFlv","diff":"VQpL12","mobile":"hur5if"};